import { render, staticRenderFns } from "./supplys.vue?vue&type=template&id=c24ca6c6&scoped=true"
import script from "./supplys.vue?vue&type=script&lang=js"
export * from "./supplys.vue?vue&type=script&lang=js"
import style0 from "./supplys.vue?vue&type=style&index=0&id=c24ca6c6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24ca6c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c24ca6c6')) {
      api.createRecord('c24ca6c6', component.options)
    } else {
      api.reload('c24ca6c6', component.options)
    }
    module.hot.accept("./supplys.vue?vue&type=template&id=c24ca6c6&scoped=true", function () {
      api.rerender('c24ca6c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/adjustment_supply/form/supplys.vue"
export default component.exports